import React from 'react';
import { useState } from 'react';
import PricingTable from '.';

export default function PricingTableList() {
  const [tab, setTab] = useState('monthly');
  return (
    <div className="cs_tabs cs_style1">
      <ul className="cs_tab_links cs_style1 cs_mp0 cs_pricing_control">
        <li
          className={tab === 'monthly' ? 'active' : ''}
          onClick={() => setTab('monthly')}
        >
          <span>Monthly</span>
          <span className="cs_switch"></span>
        </li>
        <li
          className={tab === 'yearly' ? 'active' : ''}
          onClick={() => setTab('yearly')}
        >
          <span>Yearly</span>
        </li>
      </ul>
      <div className="row cs_gap_y_30">
        <div className="col-lg-4">
          {tab === 'monthly' && (
            <PricingTable
              title="Silver"
              subTitle="Enjoy access to top-quality Padel, Futsal, and Multi Purpose facilities with essential benefits."
              price="20k"
              currency="PKR"
              timeline="monthly"
              features={[
                'Limited court access',
                'Weekday bookings',
              
              ]}
              btnText="Choose Packedge"
              btnLink="/"
            />
          )}
          {tab === 'yearly' && (
            <PricingTable
              title="Silver"
              subTitle="Enjoy access to top-quality Padel, Futsal, and Multi Purpose facilities with essential benefits."
              price="30k"
              currency="pkr"
              timeline="yearly"
              features={[
                'Limited content',
                'Weekday bookings',
               
              ]}
              btnText="Choose Packedge"
              btnLink="/"
            />
          )}
        </div>
        <div className="col-lg-4">
          {tab === 'monthly' && (
            <PricingTable
              title="Gold"
              subTitle="Enjoy access to top-quality Padel, Futsal, and Multi Purpose facilities with essential benefits."
              price="40k"
              currency="PKR"
              timeline="monthly"
              features={[
                'Limited content',
                'Weekday bookings',
              
              ]}
              btnText="Choose Packedge"
              btnLink="/"
              popular
            />
          )}
          {tab === 'yearly' && (
            <PricingTable
              title="Gold"
              subTitle="Control your choices for effective business growth and more customers."
              price="70k"
              currency="PKR"
              timeline="yearly"
              features={[
                'Limited content',
                'Social ad campaign',
            
              ]}
              btnText="Choose Packedge"
              btnLink="/"
              popular
            />
          )}
        </div>
        <div className="col-lg-4">
          {tab === 'monthly' && (
            <PricingTable
              title="Platinum"
              subTitle="Control your choices for effective business growth and more customers."
              price="70k"
              currency="PKR"
              timeline="monthly"
              features={[
                'Limited Courts ',
                'Weekend Bookins ',
              ]}
              btnText="Choose Packedge"
              btnLink="/"
            />
          )}
          {tab === 'yearly' && (
            <PricingTable
              title="Platinum"
              subTitle="Control your choices for effective business growth and more customers."
              price="89k"
              currency="PKR"
              timeline="yearly"
              features={[
                'Limited Courts',
                'Weekend Bookins ',
             
              ]}
              btnText="Choose Packedge"
              btnLink="/"
            />
          )}
        </div>
      </div>
    </div>
  );
}
